import { $axios } from './config';

const url = '/Cases';

const getDashboardStatsForLoggedInInternalUser = async () => {
    return $axios.get(`${url}/getDashboardStatsForLoggedInInternalUser`);
};

const getAllCases = async (payload = {}, isReport = false) => {
    return $axios.post(`${url}/getAllCases?isReport=${isReport}`, payload);
};

const getAllCaseDetails = async (caseId) => {
    return $axios.get(`${url}/getCaseDetailsByCaseId?caseId=${caseId}`);
};

const getCaseUpdateHistoryByCaseId = async (caseId) => {
    return $axios.get(`${url}/getCaseUpdateHistoryByCaseId?caseId=${caseId}`);
};

const getAllBank2BankBreachedCases = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getAllBank2BankBreachedCases?isReport=${isReport}`,
        payload
    );
};

const getUnassignedBank2BankBreachedCases = async (
    payload = {},
    isReport = false
) => {
    return $axios.post(
        `${url}/getUnassignedBank2BankBreachedCases?isReport=${isReport}`,
        payload
    );
};

const getUnassignedBreachedCases = async (
    payload = {},
    isReport = false,
    groupId = ''
) => {
    return $axios.post(
        `${url}/getUnassignedBreachedCases?groupId=${groupId}&isReport=${isReport}`,
        payload
    );
};

const getPublicUnassignedBreachedCases = async (
    payload = {},
    isReport = false,
    groupId = ''
) => {
    return $axios.post(
        `${url}/getPublicUnassignedBreachedCases?groupId=${groupId}&isReport=${isReport}`,
        payload
    );
};

const getTeamLeadAssignedCases = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getTeamLeadAssignedCases?isReport=${isReport}`,
        payload
    );
};

const getUserAssignedCases = async (userId, payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getUserAssignedCases?userId=${userId}&isReport=${isReport}`,
        payload
    );
};

const submitCases = async (formData) => {
    return $axios.post(`${url}/SubmitCasesInXml`, formData);
};

const getUserAssignedCasesAndImmediateWorkflowTeamMembers = async (
    payload = {},
    isReport = false
) => {
    return $axios.post(
        `${url}/getUserAssignedCasesAndImmediateWorkflowTeamMembers?isReport=${isReport}`,
        payload
    );
};

const getAllClosedCases = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getAllClosedCases?isReport=${isReport}`,
        payload
    );
};

const getLoggedInUserAssignedCases = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getLoggedInUserAssignedCases?isReport=${isReport}`,
        payload
    );
};

const getAllCasesUserhasEverBeenAssignedTo = async (
    payload = {},
    isReport = false
) => {
    return $axios.post(
        `${url}/getAllCasesUserhasEverBeenAssignedTo?isReport=${isReport}`,
        payload
    );
};

const getMyPendingBankCases = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getMyPendingBankCases?isReport=${isReport}`,
        payload
    );
};

const getMyRespondedPendingBankCases = async (
    payload = {},
    isReport = false
) => {
    return $axios.post(
        `${url}/getMyRespondedPendingBankCases?isReport=${isReport}`,
        payload
    );
};

const getMyNotRespondedPendingBankCases = async (
    payload = {},
    isReport = false
) => {
    return $axios.post(
        `${url}/getMyNotRespondedPendingBankCases?isReport=${isReport}`,
        payload
    );
};

const getAllClosedCasesByGroupId = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getAllClosedCasesByGroupId?isReport=${isReport}`,
        payload
    );
};

const getCasesUploadSummaryForCPD = async (
    skip = 0,
    take = 50,
    isReport = false,
    instId = ''
) => {
    return $axios.get(
        `${url}/GetCasesUploadSummaryForCPD?skip=${skip}&take=${take}&isReport=${isReport}${
            instId ? `&instId=${instId}` : ''
        }`
    );
};

const GetRootCauseAnalysisUploadForInstitution = async (year = '', instId = '') => {
    return $axios.get(`${url}/GetRootCauseAnalysisUploadForInstitution?year=${year}&instId=${instId}`);
};

const GetRootCauseAnalysisUploadForInstitutionById = async (rootCauseAnalysisUploadId) => {
    return $axios.get(`${url}/GetRootCauseAnalysisUploadForInstitutionById?rootCauseAnalysisUploadId=${rootCauseAnalysisUploadId}`);
};

const getFIUnassignedBreachedCases = async (
    payload = {},
    isReport = false,
    groupId = ''
) => {
    return $axios.post(
        `${url}/getFIUnassignedBreachedCases?groupId=${groupId}&isReport=${isReport}`,
        payload
    );
};

const getCPDUnassignedBreachedCases = async (
    payload = {},
    isReport = false,
    groupId = ''
) => {
    return $axios.post(
        `${url}/getCPDUnassignedBreachedCases?groupId=${groupId}&isReport=${isReport}`,
        payload
    );
};

const getAllReportedFIsCases = async (payload = {}, isReport = false) => {
    return $axios.post(
        `${url}/getAllReportedFIsCases?isReport=${isReport}`,
        payload
    );
};

const ValidateReturn = async (rootCauseAnalysisUploadId = '') => {
    return $axios.post(
        `${url}/ValidateReturn?rootCauseAnalysisUploadId=${rootCauseAnalysisUploadId}`
    );
};

export {
    getAllCases,
    submitCases,
    getUserAssignedCases,
    getCPDUnassignedBreachedCases,
    getFIUnassignedBreachedCases,
    getAllCaseDetails,
    getCaseUpdateHistoryByCaseId,
    getDashboardStatsForLoggedInInternalUser,
    getUnassignedBreachedCases,
    getPublicUnassignedBreachedCases,
    getTeamLeadAssignedCases,
    getAllClosedCases,
    getLoggedInUserAssignedCases,
    getMyPendingBankCases,
    getCasesUploadSummaryForCPD,
    getAllClosedCasesByGroupId,
    getAllCasesUserhasEverBeenAssignedTo,
    getAllReportedFIsCases,
    getMyNotRespondedPendingBankCases,
    getMyRespondedPendingBankCases,
    getUnassignedBank2BankBreachedCases,
    getAllBank2BankBreachedCases,
    GetRootCauseAnalysisUploadForInstitution,
    ValidateReturn,
    GetRootCauseAnalysisUploadForInstitutionById
};
